import { Button, Card, Stack, Text, Group } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import useTransientStore from "../../../data/transcientStore";
import { useTranslation } from "../../../hooks/useTranslation";
import { SettingsViewId } from "../settingsLandingData";
import { useSettingsPageAccess } from "../useSettingsPageAccess";

interface SettingsLandingProps {
  onOpenView: (viewId: SettingsViewId) => void;
}

export default function SettingsLanding({
  onOpenView,
}: Readonly<SettingsLandingProps>) {
  const selectedAddressSystemId =
    useTransientStore((state) => state.selectedAddressSystem?.id) ?? 0;
  const { getTranslation } = useTranslation({
    pageId: 520,
    addressSystemId: selectedAddressSystemId,
    autoLoad: true,
  });
  const { visibleLinks } = useSettingsPageAccess();

  return (
    <Card withBorder radius="lg" px="xl" py="lg" shadow="sm">
      <Stack gap="md">
        <Stack gap="xs">
          {visibleLinks.map((link) => {
            const label =
              getTranslation(link.translationKey) || link.defaultLabel;
            return (
              <Button
                key={link.id}
                variant="subtle"
                color="blue"
                justify="space-between"
                rightSection={<IconChevronRight size={16} />}
                onClick={() => onOpenView(link.id)}
                styles={{
                  root: {
                    height: "auto",
                    padding: "8px 10px",
                  },
                  inner: {
                    justifyContent: "space-between",
                  },
                  label: {
                    width: "100%",
                  },
                }}
              >
                <Group gap="xs" wrap="nowrap" justify="space-between">
                  <Text size="md" fw={600} c="blue">
                    {label}
                  </Text>
                </Group>
              </Button>
            );
          })}
        </Stack>
        {visibleLinks.length === 0 && (
          <Text c="dimmed" size="sm">
            {getTranslation("SETTINGS_NO_LINKS_FOR_ROLE") ||
              "No settings links match your permissions."}
          </Text>
        )}
      </Stack>
    </Card>
  );
}
